module.exports = __webpack_public_path__ + "img/socketSwivels.905d521a.png";